import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

const DailyMealsInfo = ({ dailyMeals = [] }) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (dailyMeals.length === 0) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t("mealAvailability.dailyMealsTitle")}
      </label>
      <div className="relative" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="w-full flex items-center justify-between p-3 border border-blue-300 rounded-md bg-blue-50 text-left focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-400 transition-colors"
        >
          <div className="flex items-center flex-1">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-blue-900 font-medium">
                {t("mealAvailability.viewDailyMeals")} ({dailyMeals.length})
              </span>
            </div>
          </div>
          <ChevronDown 
            className={`h-5 w-5 text-blue-600 transition-transform duration-200 ${
              isDropdownOpen ? 'transform rotate-180' : ''
            }`} 
          />
        </button>

        {isDropdownOpen && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-80 overflow-hidden">
            <div className="p-3 border-b border-gray-200 bg-blue-50">
              <p className="text-sm font-medium text-blue-900 mb-1">
                {t("mealAvailability.dailyMealsAlwaysAvailable")}
              </p>
              <p className="text-xs text-blue-700">
                {t("mealAvailability.dailyMealsDescription")}
              </p>
            </div>
            <div className="max-h-60 overflow-y-auto">
              {dailyMeals.map((meal) => (
                <div
                  key={meal.id}
                  className="p-3 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-gray-900">{meal.name}</span>
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      {t("mealAvailability.alwaysAvailable")}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DailyMealsInfo;
